export const PLACEHOLDER_IMAGE = "/static/images/placeholder.png"

export const SIZE_TO_PX = {
  sm: 48,
  md: 60,
} as const
